import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right-angle",
  "use": "icon-arrow-right-angle-usage",
  "viewBox": "0 0 13.604 12.236",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.604 12.236\" id=\"icon-arrow-right-angle\"><g transform=\"translate(-3.213 -3.27)\"><path d=\"M15.76,4.808,4.27,14.45\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" /><path d=\"M7.254,4.081l8.507.726L15,13.311\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol